 
import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  HostListener,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { FormAddDocumentComponent } from '../../shared/form-add-document/form-add-document.component';
import { FormAddNotesComponent } from '../form-add-notes/form-add-notes.component';
import { TimelineComponent } from '../../timeline/timeline.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { VehicleFormComponent } from './vehicle-form/vehicle-form.component';
import { DetailsFormComponent } from './details-form/details-form.component';
import { ContractFormComponent } from './contract-form/contract-form.component';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { DeliveryFormComponent } from './delivery-form/delivery-form.component';
import { PreparationFormComponent } from './preparation-form/preparation-form.component';
import { RiskFormComponent } from './risk-form/risk-form.component';
import { ComissionFormComponent } from './comission-form/comission-form.component';
import { GeneralFormComponent } from './general-form/general-form.component';
import { ClientFormComponent } from './client-form/client-form.component';
import { GuaranteeFormComponent } from './guarantee-form/guarantee-form.component';
import { HelperModalComponent } from './helper-modal/helper-modal.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { addAbortSignal } from 'stream';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { CampaignFormComponent } from './campaign-form/campaign-form.component';
import { DuplicateIntoOfferDialogComponent } from './duplicate-into-offer-dialog/duplicate-into-offer-dialog.component';
import { EditConfigDialogComponent } from './edit-config-dialog/edit-config-dialog.component';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';
import { TelemarketingFormComponent } from './telemarketing-form/telemarketing-form.component';
import Swal from 'sweetalert2';
import { NotificationRemindersService } from '../../../core/services/notification-reminders/notification-reminders.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BadgeColorPipe } from '../../../core/pipe/badge-color.pipe';
import { BadgeClientPipe } from '../../../core/pipe/badge-client.pipe';
import { VisibilityPollingService } from '../../../core/services/visibility-polling/visibility-polling.service';
interface FileItem {
  file: File;
  selectOption: string;
  key: string;
}
interface Model {
  reference: string;
  name: string;
}
interface VehicleData {
  reference: string;
  model: Model[];
  engine: string;
}

@Component({
  selector: 'app-form-add-order',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    FormAddDocumentComponent,
    FormAddNotesComponent,
    TimelineComponent,
    NgSelectModule,
    FormsModule,
    GeneralFormComponent,
    VehicleFormComponent,
    DetailsFormComponent,
    ContractFormComponent,
    DeliveryFormComponent,
    PreparationFormComponent,
    RiskFormComponent,
    ComissionFormComponent,
    TabsFormComponent,
    ClientFormComponent,
    GuaranteeFormComponent,
    HelperModalComponent,
    CampaignFormComponent,
    TelemarketingFormComponent,
    DuplicateIntoOfferDialogComponent,
    EditConfigDialogComponent,
    BadgeColorPipe,
    BadgeClientPipe,
  ],
  providers: [],
  templateUrl: './form-add-order.component.html',
  styleUrl: './form-add-order.component.css',
})
export class FormAddOrderComponent implements OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  
  @ViewChild(FormAddDocumentComponent)
  addDocumentComponent?: FormAddDocumentComponent;
  @ViewChild(FormAddNotesComponent) addNotesComponent?: FormAddNotesComponent;
  @ViewChild(TelemarketingFormComponent) telemarketingFormComponent?: TelemarketingFormComponent;

  @ViewChild(GeneralFormComponent) generalFormComponent?: GeneralFormComponent;
  @ViewChild(CampaignFormComponent) campaignFormComponent?: CampaignFormComponent;
  @ViewChild(VehicleFormComponent) vehicleFormComponent?: VehicleFormComponent;
  @ViewChild(DetailsFormComponent) detailsFormComponent?: DetailsFormComponent;
  @ViewChild(PreparationFormComponent) preparationFormComponent?: PreparationFormComponent;
  @ViewChild(ContractFormComponent)
  contractFormComponent?: ContractFormComponent;
  @ViewChild(ClientFormComponent) clientFormComponent?: ClientFormComponent;
  @ViewChild(GuaranteeFormComponent)
  guaranteeFormComponent?: GuaranteeFormComponent;
  @ViewChild(DeliveryFormComponent)
  deliveryFormComponent?: DeliveryFormComponent;
  @ViewChild(RiskFormComponent) riskFormComponent?: RiskFormComponent;
  @ViewChild(ComissionFormComponent)
  comissionFormComponent?: ComissionFormComponent;
  @ViewChild(TimelineComponent) timelineComponent?: TimelineComponent;
  @ViewChild(DuplicateIntoOfferDialogComponent) duplicateOfferDialog?: DuplicateIntoOfferDialogComponent;
  @ViewChild(EditConfigDialogComponent) editConfigDialog?: EditConfigDialogComponent;

  @Output() backButtonClick = new EventEmitter<boolean>();

  @Output() addOrder = new EventEmitter<boolean>();
  @Output() formSubmit = new EventEmitter<any>();
  @Output() loadOrder = new EventEmitter<string>();

  @Input() orderData?: any; // Objeto opcional
  @Input() dataContainer?: any;
  @Input() document_buttons_chico = false;
  @Input() ladata: any = [];
  @Input() tab?: any;

  @Input() clientReference!: string;

  showImportantDates = false;
  showAddDropdown = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  order_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  //viene de la data
  selectTypes: any[] = [];
  newStage: string = '';
  title = '';
  activeForm = 'campaign';
  posiblesTabs: any[] = [
    'campaign',
    'general',
    'telemarketing',
    'notes',
    'doc-order',
    'client',
    'guarantee',
    'risk',
    'timeline',
    'contract',
    'vehicle',
    'delivery',
    'commission',
  ];
  clocks: any[] = [];
  docFiles: any[] = [];
  showWatchers = false;
  watchers = [];
  tags: string[] = ['Tag 1', 'Tag 2', 'Tag 3'];
  duplicateBrokerContract: any[] = [];
  stage?: any;
  rules: any = {};
  role: any;
  helper = false;
  showDuplicateTab = false;
  private readonly supplierLinkAllowedStages: Set<string> | '*' = '*';
  documentForms: string[] = ['doc-order', 'client', 'guarantee'];

  updatesTabs: any[] = [];

  helperStep = 1;
  isBrokerSales: boolean = false;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private campaignService: CampaignsService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authStateService: AuthStateService,
    private translateService: TranslateService,
    private notificationRemindersService: NotificationRemindersService,
    private visibilityPolling: VisibilityPollingService
  ) {
    const accountType = this.authStateService.getAccountType();
    const role = this.authStateService.getRole();
    this.isBrokerSales = accountType === 'broker' && role === 'sales';
  }

  ngOnDestroy(): void {
    // Cancelar todas las suscripciones
    this.destroy$.next();
    this.destroy$.complete();

    // Limpiar polling visibility-aware
    this.visibilityPolling.unregister('order-form-watchers');
  }

  setVariables() {
    this.watchers = this.orderData?.watchers || [];
    this.clocks = this.getClocks(this.orderData?.dates);
    this.duplicateBrokerContract =
      this.orderData?.duplicateBrokerContract || [];
    this.back = this.orderData?.back || '';
    this.stage = this.orderData?.stage;
    this.rules = this.orderData?.rules;
    this.draft = this.orderData ? true : false;
    this.order_reference = this.orderData?.reference;
    this.client_reference = this.orderData?.client?.reference;
    this.client = this.orderData?.client;
    this.guarantee = this.orderData?.guarantee;
    this.guarantee_reference = this.orderData?.guarantee?.reference;
  }

  getClocks(dates: any): any[] {
    if (dates) {
      this.clocks = Object.entries(this.orderData.dates)
        .filter(([_, value]) => value) // solo fechas no nulas
        .map(([key, value]) => ({
          key,
          value,
        }));
    }
    return this.clocks;
  }


  async openFormAddTagModal() {
    const message = await this.translateService.get("swal_messages.tags.add").toPromise();
    const title = await this.translateService.get("swal_messages.tags.addtitle").toPromise();

    const title_selector = await this.translateService.get("swal_messages.export.title_selector").toPromise();

    // Generar opciones dinámicamente desde this.ladata.tags
    let options = '';
    if (this.ladata?.tags && Array.isArray(this.ladata.tags)) {
      options = this.ladata.tags.map((tag: any) =>
        `<option value="${tag.reference}">${tag.name}</option>`
      ).join('');
    }

    let html = `<select id="formatSelector" class="swal2-input" style="width: 100%; border-radius: 8px;">
          ${options}
        </select> `;

    Swal.fire({
      title: title,
      text: message,
      icon: 'info',
      html: html,
      showCloseButton: true,
      showCancelButton: false,
      confirmButtonText: this.translateService.instant('buttons.addtag'),
      preConfirm: () => {
        const selector = document.getElementById('formatSelector') as HTMLSelectElement;
        return selector?.value;
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const selectedTag = result.value;
        let tags = this.orderData.tags?.map((tag: any) => tag.reference) || [];
        tags.push(selectedTag);
        this.addTag(tags);
      }
    });
  }
  deleteTag(tags: any, reference: string): void {
    this.orderService
      .deleteTags(this.orderData.reference, { tag_reference: tags })
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                //this.orderData = data.data;

                this.orderData.tags = this.orderData.tags.filter((tagRef: any) => {
                  return tagRef.reference != reference;
                });

                const nuevaURL = this.location.path();

                if (this.orderData.status !== 'draft') {
                  const index = nuevaURL.indexOf('/');
                  this.location.go(
                    nuevaURL.substring(0, index) +
                    '/orders/contracts/' +
                    this.order_reference
                  );
                }
                this.generalFormComponent?.generalForm.patchValue({
                  notes: '',
                });
                this.updatesTabs = [];
                //this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });

        },
      });

    this.refrescarFormulario();
  }

  addTag(tags: any): void {
    this.orderService
      .updateTags(this.orderData.reference, { tag_reference: tags })
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                let newtag: any = {};
                newtag.reference = data.data.added_tags[0].reference;
                newtag.name = data.data.added_tags[0].name;
                newtag.hex = data.data.added_tags[0].hex;
                this.orderData.tags.push(newtag);
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });

        },
      });

    this.refrescarFormulario();
  }


  removeTag(reference: string): void {
    let tags = this.orderData.tags;
    tags = tags.filter((tagRef: any) => tagRef.reference == reference);
    tags = tags.map((tagRef: any) => tagRef.reference);
    this.deleteTag(tags, reference);
  }

  // ============= DEALERSHIP DESDE VIN =============

  onDealershipFromVin(dealershipId: string): void {
    this.orderData.dealership_id = dealershipId;
    this.detailsFormComponent?.detailsForm.get('dealership_id')?.setValue(dealershipId);
    this.detailsFormComponent?.detailsForm.markAsDirty();
  }

  // ============= DROPDOWN AGREGAR TAG/REMINDER =============

  toggleAddDropdown(event: Event): void {
    event.stopPropagation();
    this.showAddDropdown = !this.showAddDropdown;
  }

  onAddTag(): void {
    this.showAddDropdown = false;
    this.openFormAddTagModal();
  }

  onAddReminder(): void {
    this.showAddDropdown = false;
    this.openFormAddReminderModal();
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.showAddDropdown) {
      this.showAddDropdown = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.showAddDropdown) {
      this.showAddDropdown = false;
    }
  }

  // ============= RECORDATORIOS (Notification Reminders) =============

  availableReminders: any[] = [];
  remindersLoaded = false;

  loadReminders(): Promise<void> {
    return new Promise((resolve) => {
      this.notificationRemindersService.getReminders({ pageSize: '100' }).subscribe({
        next: (response: any) => {
          this.availableReminders = response.data || [];
          this.remindersLoaded = true;
          resolve();
        },
        error: () => {
          this.remindersLoaded = true;
          resolve();
        },
      });
    });
  }

  async openFormAddReminderModal() {
    if (!this.remindersLoaded) {
      this.alertService.loading('swal_messages.please_wait');
      await this.loadReminders();
      this.alertService.close();
    }

    const title = this.translateService.instant('notification_reminders.assign_title');
    if (!this.orderData.notification_reminders) this.orderData.notification_reminders = [];

    const available = this.availableReminders;

    if (!available.length) {
      this.alertService.error('notification_reminders.no_available');
      return;
    }

    const options = available.map((r: any) =>
      `<option value="${r.reference}" data-date="${r.date || ''}" data-repeat="${r.repeat_every || ''}" data-interval="${r.repeat_interval_days || ''}">${r.title}</option>`
    ).join('');

    const labelTitle = this.translateService.instant('notification_reminders.fields.title');
    const labelDate = this.translateService.instant('notification_reminders.fields.date');
    const labelRepeat = this.translateService.instant('notification_reminders.fields.repeat_every');
    const labelInterval = this.translateService.instant('notification_reminders.fields.repeat_interval_days');
    const optNone = this.translateService.instant('notification_reminders.repeat_options.none');
    const optDaily = this.translateService.instant('notification_reminders.repeat_options.daily');
    const optWeekly = this.translateService.instant('notification_reminders.repeat_options.weekly');
    const optMonthly = this.translateService.instant('notification_reminders.repeat_options.monthly');
    const optCustom = this.translateService.instant('notification_reminders.repeat_options.custom_days');

    const firstReminder = available[0];
    const defaultDate = firstReminder?.date || '';
    const defaultRepeat = firstReminder?.repeat_every || 'none';
    const defaultInterval = firstReminder?.repeat_interval_days || '';

    Swal.fire({
      title: title,
      html: `
        <label style="display:block; text-align:left; margin:0 auto 4px; font-size:16px; font-weight:500; width:calc(100% - 4em);">${labelTitle} *</label>
        <select id="reminderSelector" class="swal2-select" style="display:block; width:100%; border-radius:8px; border:1px solid #d9dee3; font-size:13px; padding:0 0.75em; height:37px; margin:0 auto 3px;">
          ${options}
        </select>
        <label style="display:block; text-align:left; margin:12px auto 4px; font-size:16px; font-weight:500; width:calc(100% - 4em);">${labelDate} *</label>
        <input type="date" id="reminderDate" class="swal2-select" style="display:block; width:100%; border-radius:8px; border:1px solid #d9dee3; font-size:13px; padding:0 0.75em; height:37px; margin:0 auto 3px;" value="${defaultDate}" />
        <label style="display:block; text-align:left; margin:12px auto 4px; font-size:16px; font-weight:500; width:calc(100% - 4em);">${labelRepeat}</label>
        <select id="reminderRepeat" class="swal2-select" style="display:block; width:100%; border-radius:8px; border:1px solid #d9dee3; font-size:13px; padding:0 0.75em; height:37px; margin:0 auto 3px;">
          <option value="none">${optNone}</option>
          <option value="daily">${optDaily}</option>
          <option value="weekly">${optWeekly}</option>
          <option value="monthly">${optMonthly}</option>
          <option value="custom_days">${optCustom}</option>
        </select>
        <div id="intervalContainer" style="display: none;">
          <label style="display:block; text-align:left; margin:12px auto 4px; font-size:16px; font-weight:500; width:calc(100% - 4em);">${labelInterval} *</label>
          <input type="number" id="reminderInterval" class="swal2-select" style="display:block; width:100%; border-radius:8px; border:1px solid #d9dee3; font-size:13px; padding:0 0.75em; height:37px; margin:0 auto 3px;" min="1" value="${defaultInterval}" />
        </div>
      `,
      showCloseButton: true,
      showCancelButton: false,
      confirmButtonText: this.translateService.instant('notification_reminders.add_reminder'),
      didOpen: () => {
        const selector = document.getElementById('reminderSelector') as HTMLSelectElement;
        const dateInput = document.getElementById('reminderDate') as HTMLInputElement;
        const repeatSelect = document.getElementById('reminderRepeat') as HTMLSelectElement;
        const intervalContainer = document.getElementById('intervalContainer') as HTMLDivElement;
        const intervalInput = document.getElementById('reminderInterval') as HTMLInputElement;

        // Set defaults for first item
        repeatSelect.value = defaultRepeat;
        if (defaultRepeat === 'custom_days') intervalContainer.style.display = 'block';

        // On template change: preconfigure defaults
        selector.addEventListener('change', () => {
          const selected = selector.options[selector.selectedIndex];
          const date = selected.getAttribute('data-date') || '';
          const repeat = selected.getAttribute('data-repeat') || 'none';
          const interval = selected.getAttribute('data-interval') || '';
          dateInput.value = date;
          repeatSelect.value = repeat || 'none';
          intervalInput.value = interval;
          intervalContainer.style.display = repeat === 'custom_days' ? 'block' : 'none';
        });

        // On repeat change: show/hide interval
        repeatSelect.addEventListener('change', () => {
          intervalContainer.style.display = repeatSelect.value === 'custom_days' ? 'block' : 'none';
        });
      },
      preConfirm: () => {
        const ref = (document.getElementById('reminderSelector') as HTMLSelectElement)?.value;
        const date = (document.getElementById('reminderDate') as HTMLInputElement)?.value;
        const repeat = (document.getElementById('reminderRepeat') as HTMLSelectElement)?.value;
        const interval = (document.getElementById('reminderInterval') as HTMLInputElement)?.value;

        if (!date) {
          Swal.showValidationMessage(this.translateService.instant('notification_reminders.fields.date') + ' *');
          return false;
        }

        if (repeat === 'custom_days' && (!interval || parseInt(interval) < 1)) {
          Swal.showValidationMessage(this.translateService.instant('notification_reminders.fields.repeat_interval_days') + ' *');
          return false;
        }

        const payload: any = { reference: ref, date, repeat_every: repeat };
        if (repeat === 'custom_days') payload.repeat_interval_days = parseInt(interval);

        return payload;
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.assignReminder(result.value);
      }
    });
  }

  assignReminder(payload: any): void {
    this.alertService.loading('swal_messages.please_wait');
    const reminderData = this.availableReminders.find((r: any) => r.reference === payload.reference);

    this.notificationRemindersService.assignToOrder(this.orderData.reference, payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (!this.orderData.notification_reminders) this.orderData.notification_reminders = [];

          if (response.data?.assigned_reminders?.length) {
            // Check if already assigned (reasignación = update)
            const existingIdx = this.orderData.notification_reminders.findIndex(
              (r: any) => r.reference === payload.reference
            );
            if (existingIdx >= 0) {
              this.orderData.notification_reminders[existingIdx] = response.data.assigned_reminders[0];
            } else {
              this.orderData.notification_reminders.push(response.data.assigned_reminders[0]);
            }
          } else if (reminderData) {
            this.orderData.notification_reminders.push({
              reference: reminderData.reference,
              title: reminderData.title,
              channels: reminderData.channels,
            });
          }

          this.alertService.successOk('swal_messages.order_notification_reminders.order_reminders_assigned');
        },
        error: (error: any) => {
          this.alertService.error(error.error || 'swal_messages.error');
        },
      });
  }

  removeReminder(reminderReference: string): void {
    this.alertService.loading('swal_messages.please_wait');
    this.notificationRemindersService.removeFromOrder(this.orderData.reference, reminderReference)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response.data?.summary?.error_count > 0) {
            this.alertService.error('swal_messages.order_notification_reminders.order_reminders_removed_error');
            return;
          }
          this.orderData.notification_reminders = (this.orderData.notification_reminders || [])
            .filter((r: any) => r.reference !== reminderReference);
          this.alertService.successOk('swal_messages.order_notification_reminders.order_reminders_removed');
        },
        error: (error: any) => {
          this.alertService.error(error.error || 'swal_messages.error');
        },
      });
  }

  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();

  }
  time = 120000;
  ngOnInit(): void {
    const role = this.authStateService.getRole();
    this.userRole = role || '';
    this.loadReminders();
    this.visibilityPolling.register('order-form-watchers', () => {
      if (this.orderData) {
        this.updateView();
      }
    }, this.time);
    this.detectRouteType();
    this.setInitialTab();
  }
  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft'],
    });
    this.refrescarFormulario();
  }

  onSubmit() {

    if (this.activeForm === 'campaign') {
      this.onSubmitWithCampaign();
    } else {
      this.onSubmitWithoutCampaign();
    }
  }

  onSubmitWithCampaign() {
    const formValues = this.campaignFormComponent?.getForm();
    this.alertService.loading('swal_messages.please_wait_add_order');

    this.campaignService.addOrderToCampaign(formValues)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_order', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.orderData = data.data;
            this.activeForm = 'general';
            this.refrescarFormulario();
            const nuevaURL = this.location.path();
            if (!nuevaURL.includes('orders')) {
              const nuevaURL =
                this.location.path() +
                '/orders/contracts/' +
                this.order_reference;
              this.location.go(nuevaURL);
            } else {
              const index = nuevaURL.indexOf('/');
              this.location.go(
                nuevaURL.substring(0, index) +
                '/orders/contracts/' +
                this.order_reference
              );
            }
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });

  }

  onSubmitWithoutCampaign() {
    const formValues = this.getFormsValues();
    this.alertService.loading('swal_messages.please_wait_add_order');


    this.orderService.addData(formValues)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_order', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.orderData = data.data;
            this.refrescarFormulario();
            const nuevaURL = this.location.path();
            if (!nuevaURL.includes('orders')) {
              const nuevaURL =
                this.location.path() +
                '/orders/contracts/' +
                this.order_reference;
              this.location.go(nuevaURL);
            } else {
              const index = nuevaURL.indexOf('/');
              this.location.go(
                nuevaURL.substring(0, index) +
                '/orders/contracts/' +
                this.order_reference
              );
            }
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });
  }
  onSubmitDraft(): void {
    if (this.docFiles.length > 0 && this.isDocumentForm()) {
      this.addDocumentComponent?.onSubmit();
    } else {
      switch (this.activeForm) {
        case 'notes':
          this.addNotesComponent?.onSubmit(true);
          break;
        default:
          this.onSubmitOrder();
          break;
      }
    }
    this.refrescarFormulario();
  }

  isWorkshopUser: boolean = false;

  areValuesEqualWithZeroCheck(a: any, b: any): boolean {
    // Check for 0 and 0.00 equivalence
    if ((a === 0 || a === '0.00' || a === 0.00) && (b === 0 || b === '0.00' || b === 0.00)) {
      return true;
    }
    // If both are numbers, compare as numbers
    if (!isNaN(a) && !isNaN(b) && typeof a !== 'object' && typeof b !== 'object') {
      return Number(a) === Number(b);
    }
    // Fallback to strict equality
    return a === b;
  }

  onSubmitOrderFast(stage: string): void {
    /* let originalOrder = { ...this.orderData, ...this.arreglarAcentos() }; */
    let originalOrder = {
      ...this.orderData,
      ...this.arreglarAcentos(),
      ...this.getOriginalPffData()
    };

    originalOrder.notes_visibility = '';
    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    formValues['stage'] = stage;

    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        !this.areValuesEqualWithZeroCheck(formValues[key], originalOrder[key]) &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])
      ) {
        modifiedFields[key] = formValues[key];
      }
    }



    if (Object.keys(modifiedFields).length === 0) {
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }

    formValues['notes_visibility'] = this.getNotesVisibility();

    this.alertService.loading('swal_messages.updating_order');
    formValues['notes_visibility'] =
      this.generalFormComponent?.generalForm.value.notes_visibility;
    this.orderService
      .updateData(this.orderData.reference, modifiedFields)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          const orderPayload = data.data.order ?? data.data;

          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.orderData = orderPayload;
                const nuevaURL = this.location.path();

                if (this.orderData.status !== 'draft') {
                  const index = nuevaURL.indexOf('/');
                  this.location.go(
                    nuevaURL.substring(0, index) +
                    '/orders/contracts/' +
                    this.order_reference
                  );
                }
                this.generalFormComponent?.generalForm.patchValue({
                  notes: '',
                });
                this.updatesTabs = [];
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });

        },
      });

    this.refrescarFormulario();
  }

  onSubmitOrder(): void {

    let originalOrder = {
      ...this.orderData,
      ...this.arreglarAcentos(),
      ...this.getOriginalPffData()
    };

    const formValues = this.getFormsValues();
    const modifiedFields: any = {};

    for (const key in formValues) {
      if (
        formValues.hasOwnProperty(key) &&
        formValues[key] !== originalOrder[key] &&
        formValues[key] !== null &&
        formValues[key] !== 'NaN' &&
        !Number.isNaN(formValues[key])
      ) {
        if (key === 'stage') {
          if (this.orderData?.rules?.stage === 'w') {
            modifiedFields[key] = formValues[key];
          } else {
            // campo stage omitido sin permisos de escritura
          }
        } else {
          modifiedFields[key] = formValues[key];
        }
      }
    }

    if (this.guaranteeFormComponent?.guaranteeForm.dirty) {
      const guaranteeIdControl = this.guaranteeFormComponent.guaranteeForm.get('guarantee_id');
      const guaranteeRelationshipControl = this.guaranteeFormComponent.guaranteeForm.get('guarantee_relationship');

      if (guaranteeIdControl?.dirty) {
        modifiedFields.guarantee_id = guaranteeIdControl.value;
      }

      if (guaranteeRelationshipControl?.dirty) {
        modifiedFields.guarantee_relationship = guaranteeRelationshipControl.value;
      }
    }
    modifiedFields.notes_suggest = true;

    if (Object.keys(modifiedFields).length === 0) {
      // Si no hay campos modificados, no hay nada que enviar
      this.alertService.warning('swal_messages.no_changes_made');
      return;
    }
    /* formValues['notes_visibility'] =
      this.generalFormComponent?.generalForm.value.notes_visibility; */

    formValues['notes_visibility'] = this.getNotesVisibility();

    this.alertService.loading('swal_messages.updating_order');
    this.orderService
      .updateData(this.orderData.reference, modifiedFields)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          const orderPayload = data.data.order ?? data.data;

          if (data.data.next_stage != null) {
            const stageTranslation = this.translateService.instant(`badge-status_select-stage.${data.data.next_stage}`);
            const title = this.translateService.instant('swal_messages.change_stage');
            const confirmButtonText = this.translateService.instant('swal_messages.confirm');
            const cancelButtonText = this.translateService.instant('swal_messages.notes.cancel');
            const htmlMessage = `${this.translateService.instant('swal_messages.change_stage_detected')} <strong><em>${stageTranslation}</em></strong><br><br>${this.translateService.instant('swal_messages.change_stage_question')}`;

            Swal.fire({
              title: title,
              html: htmlMessage,
              icon: 'question',
              showCancelButton: true,
              reverseButtons: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: confirmButtonText,
              cancelButtonText: cancelButtonText,
              allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                  this.refrescarStage(data.data.next_stage);
                }
              });
          }

          this.alertService
            .successOk('swal_messages.order_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.orderData = orderPayload;
                const nuevaURL = this.location.path();

                if (this.orderData.status !== 'draft') {
                  const index = nuevaURL.indexOf('/');
                  if (this.role == 'Telemarketing') {
                    this.location.go(
                      nuevaURL.substring(0, index) +
                      '/orders/telemarketing-pending/' +
                      this.order_reference
                    );
                  } else {
                    this.location.go(
                      nuevaURL.substring(0, index) +
                      '/orders/contracts/' +
                      this.order_reference
                    );
                  }
                }
                this.updatesTabs = [];
                this.refrescarDocumentos();
                this.refrescarFormulario();
                this.emitAddOrder();
              }
            });
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
              if (error.code == 409) {
                window.location.reload();
              }
            }
          });
        },
      });
  }

  stringToArray(original: string): string[] {
    return original
      .split(',')
      .map(item => item.trim()); // Quita espacios en caso de que los haya
  }
  fixUnicode(str: string): string {

    return str.replace(/\\u[\dA-Fa-f]{4}/g, match => {
      return String.fromCharCode(parseInt(match.replace("\\u", ""), 16));
    });
  }


  getFormsValues(): any {
    const generalFormValues = this.generalFormComponent?.generalForm.value;
    const vehicleFormValues = this.vehicleFormComponent?.vehicleForm.value;
    const detailsFormValues = this.getModifiedDetailsFormValuesAux();

    const contractFormValues = this.contractFormComponent?.contractForm.value;
    const clientFormValues = this.clientFormComponent?.clientForm.value;
    const clientFormExtraValues = this.clientFormComponent?.clientFormExtra.value;
    const guaranteeFormValues = this.guaranteeFormComponent?.getFormChanges() || {};
    const guaranteeFormExtraValues = this.guaranteeFormComponent?.guaranteeFormExtra.value || {};
    const deliveryFormValues = this.deliveryFormComponent?.deliveryForm.value;
    const preparationFormValues = this.preparationFormComponent?.preparationForm.value;
    const comissionFormValues = this.comissionFormComponent?.comissionForm.value;
    const riskFormValues = this.riskFormComponent?.riskForm.value;

    const telemarketingFormValues = this.telemarketingFormComponent?.telemarketingForm.value;

    this.generalFormComponent?.generalForm.get('notes')?.setValue('');

    const formValues = {
      ...this.form.value,
      ...clientFormValues,
      ...clientFormExtraValues,
      ...preparationFormValues,
      ...guaranteeFormExtraValues,
      ...guaranteeFormValues,
      ...generalFormValues,
      ...vehicleFormValues,
      ...deliveryFormValues,
      ...contractFormValues,
      ...deliveryFormValues,
      ...comissionFormValues,
      ...riskFormValues,
      ...telemarketingFormValues,
      ...detailsFormValues,
    };

    // Round monetary fields to 2 decimals before sending
    const roundFields = ['monthly_fee_base', 'monthly_fee_tax', 'monthly_fee_total'];
    for (const field of roundFields) {
      if (formValues[field] !== null && formValues[field] !== undefined && formValues[field] !== '') {
        formValues[field] = parseFloat(parseFloat(formValues[field]).toFixed(2));
      }
    }

    if (this.isBrokerSales) {
      formValues.notes_visibility = 'private';
    }

    return formValues;
  }

  private getModifiedDetailsFormValuesAux(): any {
    const detailsFormComponent = this.detailsFormComponent?.detailsForm.value;
    for (const key in detailsFormComponent) {
      if (
        Array.isArray(detailsFormComponent[key]) && detailsFormComponent[key].length === 0 ||
        detailsFormComponent[key] === "[]" ||
        detailsFormComponent[key] === "[]"
      ) {
        detailsFormComponent[key] = null;
      }
    }
    let detailsFormValues = {};

    if (detailsFormComponent != undefined) {
      const fieldsToArray = [
        'vehicle_options',
        'vehicle_accesories',
        'vehicle_invoice_options_detail',
        'vehicle_invoice_accessories_detail',
        'vehicle_invoice_packs_detail',
      ];
      //const transformedData = { ...detailsFormComponent };

      fieldsToArray.forEach((field) => {
        if (field in detailsFormComponent && Array.isArray(detailsFormComponent[field])) {
          detailsFormComponent[field] = JSON.stringify(this.cleanDetailArrayData(detailsFormComponent[field]));
        }
      });

      detailsFormValues = Object.fromEntries(
        Object.entries(detailsFormComponent).filter(([key]) => !key.startsWith('vehicle_invoice_pre'))
      );
    }
    return { ...detailsFormValues };
  }

  private getModifiedDetailsFormValues(): any {
    if (!this.detailsFormComponent?.detailsForm.value || !this.detailsFormComponent.detailsForm.dirty) {
      return {};
    }

    const detailsFormValue = JSON.parse(JSON.stringify(this.detailsFormComponent.detailsForm.value));

    const modifiedFields: any = {};

    const detailFields = [
      'vehicle_invoice_options_detail',
      'vehicle_invoice_accessories_detail',
      'vehicle_invoice_packs_detail',
      'vehicle_billing_date',
      'vehicle_payment_date',
      'dealership_id'
    ];

    detailFields.forEach(field => {
      const currentValue = detailsFormValue[field];
      const originalValue = this.getOriginalDetailsValue(field);
      if (this.hasMeaningfulChange(field, currentValue, originalValue)) {
        modifiedFields[field] = currentValue;
      }
    });

    return modifiedFields;
  }

  private hasMeaningfulChange(field: string, currentValue: any, originalValue: any): boolean {
    if ((!currentValue || currentValue === '' || currentValue === '""') &&
      (!originalValue || originalValue === '' || originalValue === '""')) {
      return false;
    }
    if (field.includes('_detail') && Array.isArray(currentValue)) {
      const hasValidElements = currentValue.some((item: any) =>
        item && item.name && item.name.trim() !== ''
      );
      if (!hasValidElements) return false;
    }
    if (currentValue === '' && (originalValue === null || originalValue === undefined)) {
      return false;
    }

    return JSON.stringify(currentValue) !== JSON.stringify(originalValue);
  }

  private getOriginalDetailsValue(field: string): any {
    if (this.orderData.pff && this.orderData.pff[field] !== undefined) {
      return this.orderData.pff[field];
    }
    return this.orderData[field];
  }

  private getNotesVisibility(): string {
    if (this.isBrokerSales) {
      return 'private';
    }
    const generalFormValues = this.generalFormComponent?.generalForm.value;
    return generalFormValues?.notes_visibility || 'public';
  }

  arreglarAcentos() {
    const fieldsToArray = [
      'vehicle_options',
      'vehicle_accesories',
      'vehicle_invoice_options',
      'vehicle_invoice_accesories',
      'vehicle_invoice_options_detail',
      'vehicle_invoice_accessories_detail',
      'vehicle_invoice_packs_detail',
      'vehicle_invoice_pre_options_detail',
      'vehicle_invoice_pre_options',
      'vehicle_invoice_pre_accesories',
      'vehicle_invoice_pre_options_detail',
      'vehicle_invoice_pre_accessories_detail',
      'vehicle_invoice_pre_packs_detail',
    ]
    //const transformedData = { ...detailsFormComponent };

    fieldsToArray.forEach((field) => {
      if (this.orderData.pff[field] != null && this.orderData.pff[field] != undefined) {
        this.orderData.pff[field] = this.fixUnicode(this.orderData.pff[field]);
      }
    });

    this.orderData.pff = Object.fromEntries(
      Object.entries(this.orderData.pff).filter(
        ([key]) => !key.startsWith('vehicle_invoice_pre')
      )
    );
    return { ...this.orderData.pff };
  }

  pristineForms(): any {
    this.generalFormComponent?.generalForm.markAsPristine();
    this.vehicleFormComponent?.vehicleForm.markAsPristine();
    this.detailsFormComponent?.detailsForm.markAsPristine();
    this.contractFormComponent?.contractForm.markAsPristine();
    this.clientFormComponent?.clientForm.markAsPristine();
    this.guaranteeFormComponent?.guaranteeForm.markAsPristine();
    this.deliveryFormComponent?.deliveryForm.markAsPristine();
    this.preparationFormComponent?.preparationForm.markAsPristine();
    this.comissionFormComponent?.comissionForm.markAsPristine();
    this.riskFormComponent?.riskForm.markAsPristine();
    this.telemarketingFormComponent?.telemarketingForm.markAsPristine();
  }

  setTitle() {
    this.title = this.orderData?.client?.name
      ? this.orderData?.client?.name +
      ' ' +
      (this.orderData?.client?.lastname
        ? this.orderData?.client?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.orderData?.broker_reference
        : this.account_type === 'supplier'
          ? this.orderData?.supplier_reference
            ? this.orderData?.supplier_reference
            : this.orderData?.reference
          : this.orderData?.reference;
  }

  refrescarFormulario() {
    this.orderData.notes_visibility = '';
    this.setVariables();
    this.setTitle();
    if (this.posiblesTabs.includes(this.tab)) {
      if (this.activeForm != this.tab) {
        this.activeForm = this.tab;
      }
    }
    this.pristineForms();
    this.alertService.close();
  }

  checkUpdateForm(form: string) {
    var result: any = false;
    switch (form) {
      case 'general':
        result = this.generalFormComponent?.checkUpdateForm();
        break;
      case 'vehicle':
        result = this.vehicleFormComponent?.checkUpdateForm();
        break;
      case 'details':
        result = this.detailsFormComponent?.checkUpdateForm();
        break;
      case 'currency':
        result = this.contractFormComponent?.checkUpdateForm();
        break;
      case 'client':
        result = this.clientFormComponent?.checkUpdateForm();
        break;
      case 'guarantee':
        result = this.guaranteeFormComponent?.checkUpdateForm();
        break;
      case 'delivery':
        result = this.deliveryFormComponent?.checkUpdateForm();
        break;
      case 'preparation':
        result = this.preparationFormComponent?.checkUpdateForm();
        break;
      case 'commission':
        result = this.comissionFormComponent?.checkUpdateForm();
        break;
      case 'risk':
        result = this.riskFormComponent?.checkUpdateForm();
        break;
      case 'telemarketing':
        result = this.telemarketingFormComponent?.checkUpdateForm();
        break;
    }
    if (result) {
      if (!this.updatesTabs.includes(form)) {
        this.updatesTabs.push(form);
      }
    }
  }

  goDocs() {
    this.activeForm = 'doc-order';
  }

  changeForm(form: string) {
    if (form !== 'duplicate-offer') {
      this.showDuplicateTab = false;
    }
    if (form !== 'edit-config') {
      this.showEditConfigTab = false;
    }
    this.checkUpdateForm(this.activeForm);
    if (this.document_buttons_chico) {
      this.emitCloseClientForm.emit(true);
      this.emitCloseAssigneeForm.emit(true);
      this.emitCloseAddressesForm.emit(true);
      this.emitCloseMailPanel.emit(true);
      this.emitCloseCallPanel.emit(true);
    }
    if (this.docFiles.length > 0) {
      this.alertService
        .confirmation2(
          'swal_messages.files_charged_message_' + this.activeForm,
          'swal_messages.files_charged',
          'swal_messages.confirm',
          'swal_messages.back'
        )
        .then((result) => {
          if (result.isConfirmed) {
            if (this.addDocumentComponent) {
              this.actualizarEstadoArchivos([]);
              this.addDocumentComponent.actualizarArchivos([]);
            }
            this.activeForm = form;
          } else {
          }
        });
    } else {
      this.activeForm = form;
    }
    this.tab = this.activeForm;
  }

  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    //funcion de borrar vista
    this.closeView();

    const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index));
    this.resetFieldDisabled();
    this.draft = false;
    this.orderData = null;
    this.order_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
    this.backButtonClick.emit(true);
  }

  emitAddOrder() {
    this.addOrder.emit(true);
  }

  resetFieldDisabled() {
    for (const field in this.form.controls) {
      if (this.form.controls.hasOwnProperty(field)) {
        this.form.get(field)?.enable();
      }
    }
  }

  actualizarEstadoArchivos(nuevoArrayArchivos: any[]) {
    this.docFiles = nuevoArrayArchivos;
  }

  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.orderData.reference)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.orderData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  refrescarStage(stage: string) {

    this.alertService.loading('swal_messages.please_wait');
    const body = { stage: stage, automation: true };
    this.orderService.updateStage(this.orderData.reference, body)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.alertService.successOk('swal_messages.stage_changed').then((result) => {
          if (result.isConfirmed) {
            this.orderData = data.data;
            this.refrescarFormulario();
            this.activeForm = 'general';
            this.alertService.close();
          }
        });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }



  getImportanteDateColor(status: string): string {
    const statusColorMap: { [key: string]: string } = {
      sent: 'text-draft',
      delivered: 'text-self-employed',
      risk_started: 'text-individual',
      contract_signed: 'text-priority-2',
    };

    return statusColorMap[status] || 'text-individual';
  }

  isDocumentForm(): boolean {
    return this.documentForms.includes(this.activeForm);
  }

  refrescarOrder(orderData: any) {
    this.orderData = orderData;
    this.setVariables();
  }

  //DUPLICATE ORDER
  duplicateOrder() {
    this.alertService
      .confirmation(
        'swal_messages.duplicate_order_title',
        'swal_messages.duplicate_order_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');
          this.orderService.duplicateOrder(this.order_reference)
            .pipe(
              takeUntil(this.destroy$)
            )
            .subscribe({
            next: (data) => {
              this.alertService
                .successOk('swal_messages.duplicate_order_success')
                .then((result) => {
                  if (result.isConfirmed) {
                    this.orderData = data.data;
                    this.updatesTabs = [];
                    this.refrescarFormulario();
                    this.emitAddOrder();
                  }
                });
            },
            error: (error) => {
              this.alertService.error('swal_messages.order_not_found');
            },
          });
        } else {
        }
      });
  }

  // DUPLICATE INTO OFFER
  openDuplicateIntoOffer(): void {
    this.showDuplicateTab = true;
    this.changeForm('duplicate-offer');
  }

  closeDuplicateIntoOffer(): void {
    this.showDuplicateTab = false;
    this.changeForm('general');
  }

  onDuplicatedIntoOffer(orderData: any): void {
    this.showDuplicateTab = false;
    this.loadOrder.emit(orderData.reference);
  }

  // EDIT CONFIGURATION
  showEditConfigTab = false;

  get canEditConfig(): boolean {
    return !!this.orderData?.can_change_configuration;
  }

  get canSendSupplierLink(): boolean {
    if (!this.draft || this.account_type !== 'broker') return false;
    if (this.supplierLinkAllowedStages === '*') return true;
    return this.supplierLinkAllowedStages.has(this.stage);
  }

  openSupplierPublicLink(): void {
    const baseUrl = window.location.origin;
    const publicUrl = `${baseUrl}/public/orders/${this.order_reference}/supplier-update`;
    window.open(publicUrl, '_blank');
  }

  openEditConfig(): void {
    this.showEditConfigTab = true;
    this.showDuplicateTab = false;
    this.activeForm = 'edit-config';
    this.tab = this.activeForm;
  }

  closeEditConfig(): void {
    this.showEditConfigTab = false;
    this.changeForm('general');
  }

  onConfigUpdated(orderData: any): void {
    this.showEditConfigTab = false;
    this.orderData = orderData;
    this.refrescarFormulario();
    this.changeForm('general');
  }

  //HELPER
  @ViewChild('helperModal') helperModal!: HelperModalComponent;

  emitChangeBrand(brand: string) {
    this.openSelector(brand);
  }

  openSelector(brand: any) {
    this.helper = true;
    this.brand_id_modal = brand;
  }

  handleOption(option: string) {
    this.helper = false;
    this.alertService.loading();
    this.vehicleFormComponent?.fillVehicleFormForHelper(option);
    this.contractFormComponent?.fillContractFormForHelper(option);
    setTimeout(() => {
      this.alertService.close();
    }, 1000);
  }

  closeHelper() {
    this.helper = false;
  }


  //PASA MANOS DE EVENTOS//
  @Output() emitOpenAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenAssigneeCreateForm = new EventEmitter<boolean>();
  @Output() emitCloseClientForm = new EventEmitter<boolean>();
  @Output() emitCloseAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenClientForm = new EventEmitter<string>();
  @Output() emitOpenAddressesForm = new EventEmitter<boolean>();
  @Output() emitCloseAddressesForm = new EventEmitter<boolean>();
  @Output() emitOpenMailPanel = new EventEmitter<{ reference: string; email: string; name: string }>();
  @Output() emitCloseMailPanel = new EventEmitter<boolean>();
  @Output() emitOpenCallPanel = new EventEmitter<{ phone: string; name: string; clientReference: string }>();
  @Output() emitCloseCallPanel = new EventEmitter<boolean>();

  openMailPanel(data: { reference: string; email: string; name: string }) {
    this.document_buttons_chico = true;
    this.emitOpenMailPanel.emit(data);
  }

  closeMailPanel() {
    this.emitCloseMailPanel.emit(true);
  }

  openCallPanel(data: { phone: string; name: string; clientReference: string }) {
    this.emitOpenCallPanel.emit(data);
  }

  openAssigneeForm(assignee: any) {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(assignee);
  }

  openClientForm(optAdd: string) {
    this.document_buttons_chico = true;
    this.emitOpenClientForm.emit(optAdd);
  }

  openAssigneeCreateForm() {
    this.document_buttons_chico = true;
    this.emitOpenAssigneeForm.emit(true);
  }

  openAddressesForm() {
    this.document_buttons_chico = true;
    this.emitOpenAddressesForm.emit(true);
  }

  //NOTAS
  activeNotesTab: string = 'public';

  onTabChanged(tab: string) {
    this.activeNotesTab = tab;
  }

  //WATCHERS
  closeView() {
    
    if (this.order_reference) {
      this.orderService.closeView(this.order_reference)
        .pipe(
          takeUntil(this.destroy$)
        )
        .subscribe({
        next: (data) => {
        },
        error: (error) => {
          // this.alertService.error('swal_messages.order_not_found');
        }
      });
    }
  }

  closeViewOverlay() {
    if (this.order_reference) {
      this.orderService.closeView(this.order_reference)
        .pipe(
          takeUntil(this.destroy$)
        )
        .subscribe({
        next: (data) => {
        },
        error: (error) => {
          // this.alertService.error('swal_messages.order_not_found');
        }
      });
    }
    this.draft = false;
    this.orderData = null;
    this.order_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
  }

  goContract(url: string) {
    const nuevaURL = url;
    this.router.navigate([url]);
  }

  updateView() {
    this.orderService.updateView(this.order_reference)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.watchers = data.data.watchers;
        this.duplicateBrokerContract = data.data.duplicateBrokerContract;
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  autoAssignClient(reference: string) {
    if (reference && reference !== '') {
      this.alertService.loading('swal_messages.please_wait');
      this.clientFormComponent?.autoAssignClient(reference);
    }
  }

  /*************** */


  private getOriginalPffData(): any {
    if (!this.orderData.pff) return {};

    const pffData: any = {};
    const detailFields = [
      'vehicle_invoice_options_detail',
      'vehicle_invoice_accessories_detail',
      'vehicle_invoice_packs_detail'
    ];

    detailFields.forEach(field => {
      if (this.orderData.pff[field] !== null && this.orderData.pff[field] !== undefined) {
        try {
          const parsedData = JSON.parse(this.orderData.pff[field]);
          const cleanedData = this.cleanDetailArrayData(parsedData);

          pffData[field] = cleanedData.length > 0 ? JSON.stringify(cleanedData) : null;
        } catch (e) {
          console.warn(`Error procesando ${field}:`, e);
          pffData[field] = null;
        }
      } else {
        pffData[field] = null;
      }
    });

    return pffData;
  }

  private cleanDetailArrayData(data: any[]): any[] {
    if (!data || !Array.isArray(data)) return [];

    return data
      .filter(item => item && typeof item === 'object')
      .filter(item => {
        const hasValidName = item.name &&
          typeof item.name === 'string' &&
          item.name.toString().trim() !== '';
        return hasValidName;
      })
      .map(item => ({
        name: item.name.toString().trim(),
        amount:
          item.amount === '0.00' ? 0 :
            (item.amount !== null && item.amount !== undefined && item.amount !== '' ? Number(item.amount) : null)
      }))
      .filter(item => item.name !== '');
  }

  files: FileItem[] = [];

  refrescarDocumentos() {
    if (this.addDocumentComponent) {
      this.addDocumentComponent.getDocuments();

      setTimeout(() => {
        if (this.addDocumentComponent) {
          const changes = {
            orderData: {
              currentValue: this.orderData,
              previousValue: null,
              firstChange: false
            }
          };
          this.addDocumentComponent.ngOnChanges(changes as any);
        }
      }, 100);
    }
  }

  userRole: string = '';
  currentRouteType: string = '';

  private detectRouteType(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('telemarketing-pending')) {
      this.currentRouteType = 'telemarketing';
    } else {
      this.currentRouteType = 'general';
    }
  }

  private setInitialTab(): void {
    if (this.userRole === 'Telemarketing' || this.currentRouteType === 'telemarketing') {
      this.activeForm = 'telemarketing';
    } else {
      this.activeForm = 'general';
    }
  }

}
